import { combineReducers } from 'redux';
import { reducer as OidcReducer } from 'redux-oidc';
import { AppState } from './rootReducerTypes';
import hamListReducer from './reducersAndActions/hamListActionsAndReducer';
import userInfoReducer from './reducersAndActions/userInfoActionsAndReducer';
import dashboardReducer from './reducersAndActions/dashboardActionsAndReducers';
import discrepanyListReducer from './reducersAndActions/discrepancyListActionsAndReducer';
import terminologiesReducer from './reducersAndActions/terminologiesActionsAndReducer';
import createOrderReducer from './reducersAndActions/createOrderActionsAndReducer';

const rootReducer = combineReducers<AppState>({
  hamList: hamListReducer,
  userState: OidcReducer,
  userInformationState: userInfoReducer,
  dashboardState: dashboardReducer,
  discrepancyList: discrepanyListReducer,
  terminologyState: terminologiesReducer,
  createOrderState: createOrderReducer,

});

export { rootReducer };